import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';

interface PopupProps {
    dispatch: ({ type }: { type: string, [key: string]: any }) => void;
    window: Window;
    popup: { show?: boolean, children?: any; onClose?: () => void; };
};

const styles = (multiplier) => ({
    button: RX.Styles.createButtonStyle({
        padding: 0,
        position: 'absolute',
        right: 16 * multiplier,
        top: 16 * multiplier,
    }),
    close: RX.Styles.createTextStyle({
        fontSize: 20 * multiplier,
        fontWeight: 'bold',
    }),
    popup: RX.Styles.createViewStyle({
        alignItems: 'center',
        backgroundColor: colors.white,
        height: 300 * multiplier,
        justifyContent: 'center',
        minWidth: 300 * multiplier,
        padding: 16 * multiplier,
    }),
    wrapper: RX.Styles.createViewStyle({
        alignItems: 'center',
        backgroundColor: 'rgba(204, 204, 204, .6)',
        justifyContent: 'center',
        left: 0,
        position: 'absolute',
    })
});

export class Popup extends RX.Component<PopupProps, RX.CommonProps & PopupProps> {
    constructor(props: PopupProps) {
        super(props);
    }

    public render() {
        const { window: { height, width, multiplier }, popup: { show, children, onClose }, dispatch } = this.props;
        return (
            show ? <RX.View
                restrictFocusWithin={true}
                style={[styles(multiplier).wrapper, { top: window ? window.pageYOffset : 0, width, height }]}>
                <RX.View style={styles(multiplier).popup} >
                    {children}
                    <RX.Button
                        autoFocus={true}
                        onPress={() => dispatch({ type: 'CLOSE_POPUP' })}
                        style={styles(multiplier).button}
                        onKeyPress={(event) => {
                            const escKeyCode = 27;
                            if (event.keyCode === escKeyCode) {
                                dispatch({ type: 'CLOSE_POPUP' });
                            }
                        }}>
                        <RX.Text
                            style={styles(multiplier).close}>X
            </RX.Text>
                    </RX.Button>
                </RX.View>
            </RX.View> : null
        );
    }
}

export default connect(mapStateToProps)(Popup);



// WEBPACK FOOTER //
// ./src/components/popup/index.tsx